// import { CREATE_CATEGORY, CREATE_CATEGORY_ERROR } from "../actions/admin/Admin";

const initState = {
  categories: [],
  superCategories: [],
  menuItems: [],
  subCategories: [],
  allVendors: [],
  zipcodes: [],
  promocodes: [],
  allOrders: [],
  products: [],
  vendorOrders: [],
  restaurantCategories: [],
  restaurantType: [],
  distance: {},
  pinCodes: [],
  orderList: [],
  commission:{}
};

const adminReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CREATE_SUPERCATEGORY':;
      return state;
    case 'CREATE_SUPERCATEGORY_ERROR':
      return state;
    case 'UPDATE_SUPERCATEGORY':
      return state;
    case 'UPDATE_SUPERCATEGORY_ERROR':
      return state;
    case 'GET_SUPERCATEGORY':
      return { ...state, superCategories: action.payload.data };
    case 'GET_SUPER_CATEGORY_DETAILS':
      return { ...state, superCategoryDetails: action.payload.data };
    case 'GET_MENUS':
      return { ...state, menuItems: action.payload.data };
    case 'GET_MENU_DETAILS':
      return { ...state, menuDetails: action.payload.data };
    case 'CREATE_MENU':
      return state;
    case 'CREATE_MENU_ERROR':
      return state;
    case 'UPDATE_MENU':
      return state;
    case 'UPDATE_MENU_ERROR':
      return state;
    case 'GET_ALL_CATEGORY':
      return { ...state, categories: action.payload.data };
    case 'CREATE_CATEGORY':
      return state;
    case 'CREATE_CATEGORY_ERROR':
      return state;
    case 'UPDATE_CATEGORY':
      return state;
    case 'UPDATE_CATEGORY_ERROR':
      return state;
    case 'GET_CATEGORY_DETAILS':
      return { ...state, categoryDetails: action.payload.data };
    case 'GET_ALL_SUBCATEGORY':
      return { ...state, subCategories: action.payload.data };
    case 'CREATE_SUB_CATEGORY':
      return state;
    case 'CREATE_SUB_CATEGORY_ERROR':
      return state;
    case 'UPDATE_SUB_CATEGORY':
      return state;
    case 'UPDATE_SUB_CATEGORY_ERROR':
      return state;
    case 'GET_SUB_CATEGORY_DETAILS':
      return { ...state, subCategoryDetails: action.payload.data };
    case 'ADD_SUBCATEGORY':
      return state;
    case 'ADD_SUBCATEGORY_ERROR':
      return state;
    case 'GET_ALL_VENDORS':
      return { ...state, allVendors: action.payload.data };
    case 'GET_ALL_EVENTS':
      return { ...state, allEvents: action.payload.data };
    case 'GET_ALL_EVENTS_BY_IP':
      return { ...state, allEventsByIp: action.payload.data };
    case 'GET_COLUMN_NAMES':
      return { ...state, columnNames: action.payload.data };
    case 'GET_ALL_DISCOUNTS':
      return { ...state, allDiscounts: action.payload.data };
    case 'GET_CITY_CATEGORY_ERROR':
      return state;
    case 'GET_ALL_CATEGORY_ERROR':
      return state;
    case 'GET_ALL_SUBCATEGORY_ERROR':
      return state;
    case 'GET_ALL_VENDORS_ERROR':
      return state;
    case 'ADD_VENDOR':
      return state;
    case 'GET_VENDOR_DETAILS':
      return { ...state, vendorDetails: action.payload.data };
    case 'ADD_VENDOR_ERROR':
      return state;
    case 'UPDATE_VENDOR':
      return state;
    case 'UPDATE_VENDOR_ERROR':
      return state;
    case 'GET_VENDOR':
      return action.payload.data;
    case 'GET_VENDOR_ERROR':
      return state;
    case 'GET_ZIPCODE':
      return { ...state, zipcodes: action.payload.zipcode };
    case 'GET_ZIPCODE_ERROR':
      return state;
    case 'GET_PROMOCODE':
      return { ...state, promocodes: action.payload.data.promocode };
    case 'GET_PROMOCODE_ERROR':
      return state;
    case 'GET_RESTAURANT_CATEGORY':
      return { ...state, restaurantCategories: action.payload.items };
    case 'GET_RESTAURANT_CATEGORY_ERROR':
      return state;
    case 'APPROVE_VENDOR':
      return state;
    case 'APPROVE_VENDOR_ERROR':
      return state;
    case 'ADD_PRODUCT':
      return state;
    case 'ADD_PRODUCT_ERROR':
      return state;
    case 'DISCOUNT_DETAIL':
      return { ...state, discount: action.payload.data };
    case 'DRIVER_DETAIL':
      return { ...state, driver: action.payload.data };
    case 'USERS_TRANSACTION_LIST':
      return { ...state, userTransactions: action.payload.data };
    case 'GET_SINGLE_VENDOR_DETAILS':
      return { ...state, promocodes: action.payload.data.promocode };
    case 'GET_SINGLE_VENDOR_DETAILS_ERROR':
      return state;
    case 'GET_ALL_ORDERS':
      return { ...state, allOrders: action.payload.data };
    case 'GET_ALL_USERS':
      return { ...state, allUsers: action.payload.data, allUsersCount: action.payload.total_data };
    case 'GET_ALL_DRIVERS':
      return { ...state, allDrivers: action.payload.data };
    case 'GET_ALL_SMS':
      return { ...state, allSms: action.payload.data, allSmsCount: action.payload.total_data };
    case 'GET_ALL_DISTANCE':
      return { ...state, distance: action.payload.data };
    case 'CREATE_RESTAURANT_TYPE':
      return state;
    case 'CREATE_RESTAURANT_TYPE_ERROR':
      return state;
    case 'UPDATE_RESTAURANT':
      return state;
    case 'GET_RESTAURANT_TYPE_DETAILS':
      return { ...state, restaurantTypeDetails: action.payload.data };
    case 'GET_RESTAURANT_TYPE':
      return { ...state, restaurantType: action.payload.data };
    case 'UPDATE_DISTANCE_SUCCESS':
      return state;
    case 'GET_PIN_CODE':
      return { ...state, pinCodes: action.payload.data, pinCodesCount: action.payload.count};
    case 'ADMIN_API_PROGRESS':
      return { ...state, apiLoading: action.payload };
    case 'GET_ORDER_LIST':
      return { ...state, orderList: action.payload.data, orderCount: action.payload.total_data };
    case 'PAGE_COUNT':
      return { ...state, pageCount: action.payload };
      case 'UPDATE_ADMIN_COMMISSION':
        return { ...state, commission: action.data };
    default:
      return state;
  }
};

export default adminReducer;
